// extracted by mini-css-extract-plugin
module.exports = {"container":"ContractDetails_container__b3D4P","divider":"ContractDetails_divider__29hct"};